import {Injectable} from '@angular/core';
// Solo tipo: evita la dependencia circular en tiempo de ejecucion con
// usuario.model.ts (ese modelo importa este repositorio para inyeccion DI).
import type {Usuario} from "../../../../shared/models/usuario.model";
// La entidad es pura (sin imports): hidratarla no crea ningun ciclo y
// conserva todos los getters que usa la app (getUsuario_nombres, etc.).
import {UsuarioEntity} from "../../../../shared/entity/usuario.entity";
import {EmpresaEntity} from "../../../../shared/entity/empresa.entity";

@Injectable({
    providedIn: 'root'
})

export class LocalUsuarioRepository {

    constructor() {
    }

    /**
     * Datos de sesión
     */


    public obtenerToken() {
        return localStorage.getItem('token');
    }

    public guardarToken(token: string) {
        localStorage.setItem('token', token);
    }

    public eliminarToken() {
        localStorage.removeItem('token');
    }

    public obtenerUsuarioSesion(): Usuario {
        // Hidrata una instancia real de UsuarioEntity (misma copia de
        // propiedades que hacia Usuario.build). No se importa la clase
        // Usuario para no crear un ciclo en runtime con usuario.model.ts.
        const data = JSON.parse(localStorage.getItem('usuarioSesion')) ?? {};
        const usuario = new UsuarioEntity();
        // tslint:disable-next-line:forin
        for (const propiedad in data) {
            usuario[propiedad] = data[propiedad];
        }
        return (usuario as unknown) as Usuario;
    }

    public guardarUsuarioSesion(usuarioObj: Usuario) {
        localStorage.setItem('usuarioSesion', JSON.stringify(usuarioObj));
    }

    public eliminarUsuarioSesion() {
        localStorage.removeItem('usuarioSesion');
    }

    public guardarEmpresaSesion(sesionData: any) {
        localStorage.setItem('empresa_id', sesionData?.empresa_id);
        localStorage.setItem('empresa_ruc', sesionData?.empresa_ruc);
        localStorage.setItem('empresa_nombre', sesionData?.empresa_nombre);
        localStorage.setItem('empresa_urllogo', sesionData?.empresa_urllogo);
    }

    public obtenerEmpresaSesion(): any {
        return {
            empresa_id: localStorage.getItem('empresa_id'),
            empresa_ruc: localStorage.getItem('empresa_ruc'),
            empresa_nombre: localStorage.getItem('empresa_nombre'),
            empresa_urllogo: localStorage.getItem('empresa_urllogo')
        };
    }

    public guardarEmpresasListSesion(empresaList: EmpresaEntity[]) {
        localStorage.setItem('empresaList', JSON.stringify(empresaList));
    }

    public obtenerEmpresasListSesion(): EmpresaEntity[] {
        return JSON.parse(localStorage.getItem('empresaList'));
    }

    public guardarPermisosListSesion(permisosList: any[]) {
        localStorage.setItem('permisosList', JSON.stringify(permisosList));
    }
    public obtenerPermisosListSesion(): any[] {
        return JSON.parse(localStorage.getItem('permisosList'));
    }
    public checkPermission(permissioncodes: any[]): boolean {
        if (permissioncodes?.length === 0) { return true; }
        const permisosLS = localStorage.getItem('permisosList');
        if (permisosLS === null || permisosLS === undefined || permisosLS === ''){
            return false;
        }
        else{
            const permisosList: any[] = JSON.parse(permisosLS);
            for (const item of permissioncodes) {
                if (permisosList.includes(item)) {
                    return true;
                }
            }
        }
        return false;
    }

}
